function lightbox(trigger) {
    function isAutoCarouselActive() {
        return document.querySelector('.splide') !== null;
    }

    function getCaption(img) {
        var fig = img.closest('figure');
        if (fig) {
            var cap = fig.querySelector('figcaption');
            if (cap) return cap.innerHTML.trim();
        }
        return img.alt || '';
    }

    function collectImages() {
        var imgs = [];
        var seen = new Set();

        function push(img) {
            if (img && !seen.has(img) && !img.closest('.gh-bottomrail') && !img.closest('a')) {
                seen.add(img);
                imgs.push(img);
            }
        }

        document.querySelectorAll('.gh-article-image').forEach(function (el) {
            if (el.tagName === 'IMG') {
                push(el);
            } else {
                el.querySelectorAll('img').forEach(push);
            }
        });

        document.querySelectorAll('.gh-content img').forEach(push);

        return imgs;
    }

    function pickLargestFromSrcset(img) {
        var srcset = img.getAttribute('srcset');
        if (!srcset) return null;
        var bestUrl = null;
        var bestW = 0;
        srcset.split(',').forEach(function (entry) {
            entry = entry.trim();
            if (!entry) return;
            var parts = entry.split(/\s+/);
            var url = parts[0];
            var w = 0;
            if (parts[1] && /w$/.test(parts[1])) {
                w = parseInt(parts[1], 10) || 0;
            }
            if (w > bestW) {
                bestW = w;
                bestUrl = url;
            }
        });
        return bestUrl ? { url: bestUrl, width: bestW } : null;
    }

    function buildItem(img) {
        var origW = parseInt(img.getAttribute('width'), 10) || img.naturalWidth || 0;
        var origH = parseInt(img.getAttribute('height'), 10) || img.naturalHeight || 0;
        var displayedSrc = img.currentSrc || img.src;

        var best = pickLargestFromSrcset(img);
        var src, w, h;
        if (best && best.url) {
            src = best.url;
            // If we're loading a resized variant smaller than the original,
            // tell PhotoSwipe the variant's dimensions so it doesn't upscale.
            if (origW && best.width && best.width < origW) {
                w = best.width;
                h = origH ? Math.round(origH * (best.width / origW)) : best.width;
            } else {
                w = origW || best.width;
                h = origH;
            }
        } else {
            src = displayedSrc;
            w = origW;
            h = origH;
        }

        return {
            src: src,
            msrc: displayedSrc,
            w: w,
            h: h,
            title: getCaption(img),
            el: img,
        };
    }

    function openAtImage(clicked) {
        var items;
        var index;

        if (isAutoCarouselActive()) {
            items = [buildItem(clicked)];
            index = 0;
        } else {
            var imgs = collectImages();
            index = imgs.indexOf(clicked);
            if (index < 0) {
                imgs.unshift(clicked);
                index = 0;
            }
            items = imgs.map(buildItem);
        }

        var pswpElement = document.querySelectorAll('.pswp')[0];
        if (!pswpElement) return;

        var options = {
            bgOpacity: 1,
            closeOnScroll: true,
            fullscreenEl: false,
            history: false,
            index: index,
            shareEl: false,
            zoomEl: false,
            getThumbBoundsFn: function (i) {
                var thumbnail = items[i].el;
                if (!thumbnail) return null;
                var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                var rect = thumbnail.getBoundingClientRect();
                return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
            },
        };

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    }

    document.querySelectorAll(trigger).forEach(function (el) {
        if (el.closest('.gh-bottomrail')) return;
        if (el.closest('a')) return;
        el.addEventListener('click', function (e) {
            var img = e.target.closest('img') || el.querySelector('img') || (el.tagName === 'IMG' ? el : null);
            if (!img) return;
            if (img.closest('.gh-bottomrail')) return;
            if (img.closest('a')) return;
            e.preventDefault();
            openAtImage(img);
        });
    });
}
